module.exports = require('@readcube/eventer-js').default;
